<div>
    <app-header></app-header>
</div>
<div class="main">
    <!-- <div *ngIf="!myProfile" class="d-flex mb-3 back">
        <img (click)="goBack()" src="assets/images/arrow-circle-left.svg">
        <h3 (click)="goBack()" class="ms-2 mb-0">Back</h3>
    </div> -->
    <div Class="row m-0 ">
        <!-- <div class="col-lg-2 p-0 profile mt-0 position-relative">
            <app-profile-front-page></app-profile-front-page>
        </div> -->
        <div class="col-lg-12 bg-white py-sm-3 py-md-3 pb-0">
            <!-- <app-menu-card></app-menu-card> -->
            <div class="upperimgdata bg-white">
                <div class="change-password-container">
                    <div class="d-flex flex-column">
                        <h4>{{ aboutUsData.title || 'About Us' }}</h4>
                        <span><b class="bld-text">Settings<span class="mx-2">/</span></b><span class="semi-bld-text">{{
                                aboutUsData.title || 'About Us' }}</span></span>
                    </div>
                    <!-- <div class="aboutus_layout">
                        <div class="header_img">
                            <img src="/assets/images/aboutUs/about_landing.png" alt="header_img" />

                            <div class="header_text">
                                <div class="heading">ABOUT <span class="highlight">US</span></div>
                                <div class="subheading">Welcome to EFL RAFTAARR</div>

                                <div class="description">
                                    <div class="title">Accelerate your business today</div>
                                    <div class="details">
                                        Your Gateway to Transformative Growth for Manufacturing Businesses! Imagine a
                                        world where growing and managing your manufacturing business is as seamless as a
                                        click. With EFL RAFTAARR, that vision becomes a reality. As India’s first
                                        digital ecosystem for Industrial MSMEs, we’re revolutionizing how businesses
                                        like yours operate. From enhancing your network to streamlining operations and
                                        accessing tailored solutions, everything you need is now in one place.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->



                    <!-- <div class="header_img">
                            <img src="/assets/images/aboutUs/about_landing.png" alt="header_img" />
                            <div>
                                <div>ABOUT US</div>
                                <div>Welcome to EFL RAFTAARR</div>
                                <div>
                                    <div>Accelerate your business today</div>
                                    <div>Your Gateway to Transformative Growth for Manufacturing Businesses! Imagine a world where growing and managing your manufacturing business is as seamless as a click. With EFL RAFTAARR, that vision becomes a reality. As India’s first
digital ecosystem for Industrial MSMEs, we’re revolutionizing how businesses like yours operate. From enhancing your network to streamlining operations and accessing tailored solutions, everything you need is now in one place.</div>
                                </div>
                            </div>
                        </div> -->
                    <!-- <div class="aboutus_content">
                            <p>
                                <span>{{ aboutUsData.short_description || 'Loading description...' }}</span>
                                <br><br>
                                <span>{{ aboutUsData.description || 'Loading full description...' }}</span>
                            </p>
                        </div> 
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<div>
    <!-- TOp about landing Page -->
     <!-- <div class="row">
        <div class="header_image">
            <img src="/assets/images/aboutUs/about_landing.png" alt="header_img" />
        </div>
        <div class="header_text">
            <div class="heading">ABOUT <span class="highlight">US</span></div>
            <div class="subheading">Welcome to EFL RAFTAARR</div>

            <div class="description">
                <div class="title">Accelerate your business today</div>
                <div class="details">
                    Your Gateway to Transformative Growth for Manufacturing Businesses! Imagine a
                    world where growing and managing your manufacturing business is as seamless as a
                    click. With EFL RAFTAARR, that vision becomes a reality. As India’s first
                    digital ecosystem for Industrial MSMEs, we’re revolutionizing how businesses
                    like yours operate. From enhancing your network to streamlining operations and
                    accessing tailored solutions, everything you need is now in one place.
                </div>
            </div>
        </div>
     </div> -->
    <div class="aboutus_layout">
        <div class="header_img">
            <img src="/assets/images/aboutUs/about_landing.png" alt="header_img" />

            <div class="header_text">
                <div class="heading">ABOUT <span class="highlight">US</span></div>
                <div class="subheading">Welcome to EFL RAFTAARR</div>

                <div class="description">
                    <div class="title">Accelerate your business today</div>
                    <div class="details">
                        Your Gateway to Transformative Growth for Manufacturing Businesses! Imagine a
                        world where growing and managing your manufacturing business is as seamless as a
                        click. With EFL RAFTAARR, that vision becomes a reality. As India’s first
                        digital ecosystem for Industrial MSMEs, we’re revolutionizing how businesses
                        like yours operate. From enhancing your network to streamlining operations and
                        accessing tailored solutions, everything you need is now in one place.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Offerings & Benefits -->
    <section class="row px-5">

        <h3 class="title_about_us text-center px-7  mx-4">Offerings & Benefits</h3>
        <div class="col-md-6">
            <div class="grid md:grid-cols-2 gap-6">


                <ul class="custom-bullet-list">
                    <li>
                        <!-- <img src="../../../assets/images/aboutUs/Vector.png" style="max-width: 150px;" alt="Offerings" class="Vector"> -->
                        <span class="title">Platform for Manufacturing MSMEs</span>
                        <div class="desc">Buy, sell, or upgrade industrial machinery to the latest versions.</div>
                    </li>
                    <li>
                        <!-- <img src="../../../assets/images/aboutUs/Vector.png" style="max-width: 150px;" alt="Offerings" class="Vector"> -->
                        <span class="title">Flexible Financing</span>
                        <div class="desc">Unlock tailored loan solutions designed to boost your manufacturing business.
                        </div>
                    </li>
                    <li>
                        <!-- <img src="../../../assets/images/aboutUs/Vector.png" style="max-width: 150px;" alt="Offerings" class="Vector"> -->
                        <span class="title">Production Support</span>
                        <div class="desc">Simplify the process of sourcing raw materials, hiring skilled labour, or
                            outsourcing production orders.</div>
                    </li>
                    <li>
                        <!-- <img src="../../../assets/images/aboutUs/Vector.png" style="max-width: 150px;" alt="Offerings" class="Vector"> -->
                        <span class="title">Industrial Spaces</span>
                        <div class="desc">Find manufacturing or expansion spaces with ease.</div>
                    </li>
                    <li>
                        <!-- <img src="../../../assets/images/aboutUs/Vector.png" style="max-width: 150px;" alt="Offerings" class="Vector"> -->
                        <span class="title">Business Networking</span>
                        <div class="desc">Forge meaningful partnerships, connect with peers, and grow together.</div>
                    </li>
                </ul>



            </div>
        </div>
        <div class="col-md-6 offering_image">

        </div>

    </section>


    <!-- Why Choose Us? -->
    <section class="container whychose mb-0 my-sm-5 my-md-5">
        <h2 class="title_about_us text-center mx-4">Why Choose Us?</h2>
        <div class="slidera">
            <div class="featuredlistings-slide row">
                <div class="col-12 col-sm-6 col-md-3" *ngFor="let item of whyChooseItems">
                    <div class="why-box p-3 h-100">
                        <div class="col-12 col-sm-6 col-md-3">
                            <div class="icon-wrapper mx-auto mb-3">
                                <img [src]="item.icon" alt="Icon" />
                            </div>
                        </div>

                        <p class="whychosetitle">{{item.title}}</p>
                        <p class="whychosedescription">{{item.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>



    <!-- Vision Mission -->
        <div class="row vision_mission_section position-relative">
            <div class="ellipse-793"></div>
            <div class="ellipse-794"></div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <!-- Vision Section -->
                <div class="col-12 col-sm-12 col-md-11 col-lg-11 common_vm_section vission-sec">
                    <div class="row px-3 py-3">
                        <div class="col-3 vission-img">
                            <img src="../../../assets/images/aboutUs/vission.png" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="vm-title">Vision</h4>
                            <p class="vm-desc">
                                To empower every MSME to accelerate their journey towards the next stage of growth by
                                being their trusted catalyst for success.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <!-- Mission Section -->
                <div class="col-12 col-sm-12 col-md-11 col-lg-11 common_vm_section mission-sec">
                    <div class="row px-3 py-3">
                        <div class="col-3 vission-img">
                            <img src="../../../assets/images/aboutUs/mission.png" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="vm-title">Mission</h4>
                            <p class="vm-desc">
                                Empower manufacturing ecosystem to grow by fostering collaboration, efficiency, and
                                innovation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ellipse-795"></div>
            <div class="ellipse-796"></div>
        </div>


    <!-- Core Value -->
    <section class="container core_value mb-0 my-sm-5 my-md-5">
        <div class="row">
            <div class="col-md-12">
                <h2 class="title_about_us text-center px-7  mx-4">Core Values </h2>
                <div class="row">
                    
                    <div class="col-md-4 dotted-bottom-border dotted-dot">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Innovation.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Innovation</h4>
                            <p class="cv-desc">
                                Leveraging cutting-edge technology to enable growth.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-4 dotted-bottom-border dotted-left-border dotted-dot">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Empowerment.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Empowerment</h4>
                            <p class="cv-desc">
                                Providing tools and resources to unlock potential.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-4 dotted-bottom-border dotted-left-border">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Collaboration.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Collaboration</h4>
                            <p class="cv-desc">
                                Building partnerships that drive mutual success.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-4 ">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Transparency & Integrity.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Transparency & Integrity</h4>
                            <p class="cv-desc">
                                Ensuring honesty and openness in every interaction.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-4 dotted-left-border">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Sustainability.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Sustainability</h4>
                            <p class="cv-desc">
                                Championing responsible and forward-looking business practices.
                            </p>
                        </div>
                    </div>
                    </div>
                    <div class="col-md-4 dotted-left-border">
                        <div class="row px-3 py-3">
                        <div class="col-3 core-value-img">
                            <img src="../../../assets/images/aboutUs/Customer-Centricity.svg" alt="Offerings" class="Vector">
                        </div>
                        <div class="col-9">
                            <h4 class="cv-title">Customer-Centricity</h4>
                            <p class="cv-desc">
                                Delivering value through solutions tailored to your needs.
                            </p>
                        </div>
                    </div>
                    </div>

                </div>

                
            </div>

        </div>
    </section>

    <!-- Our Leadership -->
    <section class="container our_leadership mb-5 my-sm-5 my-md-5">
        <h2 class="title_about_us text-center mb-4">Our Leadership </h2>
        <div class="row justify-content-center">
      <div class="col-12 col-sm-10 col-md-6 col-lg-4" *ngFor="let item of our_leadershipItems">
        <div class="profile-card">
          <div class="card-header-bg profile-img-body">
            <img src="{{item.icon}}" alt="Anshul Sharma" class="img-fluid profile-img">
          </div>
          <div class="card-body">
            <div class="profile-name">{{item.title}}</div>
            <div class="profile-role">{{item.description}}</div>
            <span class="arrow-icon"><a href="{{item.url}}" target="_blank"><img src="../../../assets/images/aboutUs/arrow.svg" alt=""></a></span>
          </div>
        </div>
      </div>
    </div>
       
    </section>

     <!-- about footer -->
    <section class="container about_business mb-0 my-sm-5 my-md-5">
        <div class="bus-title">
            <span>Your business growth starts here. EFL RAFTAARR is more than a platform; it’s a community where Industrial MSMEs find opportunities, solutions, and success—all in one place.</span>
        </div>
        <div class="bottom-button">
            <a href="#" class="btn  bus-button" >Get Started with EFL-RAFTAARR Today!</a>
        </div>
    </section>


    <app-footer></app-footer>
</div>